"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _countries = require("../functions/countries");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var countryCodesEnum = (0, _countries.getCountryCodes)().reduce(function (arReturn, countryCode) {
  return _extends({}, arReturn, _defineProperty({}, countryCode, countryCode));
}, {});


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/types/flow.js
// module id = 805
// module chunks = 0